import MainLayout from "../layout/MainLayout";
import ArtistTaskPage from "../pages/seller/ArtistTaskPage";

const routes = [
  {
    path: "/artist/artist-tasks",
    exact: true,
    component: ArtistTaskPage,
    title: "Artist Task page",
    layout: MainLayout,
    roles: ["Seller"],
    teamRole: "Artist",
  },
];

export default routes;
